<template>
  <div v-if="render">
    <b-row class="match-height">
      <b-col md="5">
        <b-card>
          <div class="address-list">
            <div
              v-for="(item, index) in userAddresses"
              :key="index"
              class=""
            >
              <div class="d-flex justify-content-between align-items-center">
                <b-form-radio
                  v-model="selectedAdressIndex"
                  class="text-white"
                  name="selectedAddress"
                  :value="index"
                />
                <div class="flex flex-column bg-primary mt-1 p-2 rounded text-white w-100">
                  <div class="address-title font-weight-bolder">
                    {{ item.label }}
                  </div>
                  <div class="address-content">
                    {{ item.address }}
                  </div>
                </div>
                <b-button
                  size="sm"
                  class="m-1"
                  variant="info"
                  @click="editAddress(index)"
                >
                  <feather-icon
                    icon="EditIcon"
                    size="24"
                  />
                </b-button>
                <b-button
                  size="sm"
                  class="m-1"
                  variant="danger"
                  @click="deleteAddress(index)"
                >
                  <feather-icon
                    icon="XCircleIcon"
                    size="24"
                  />
                </b-button>
              </div>
            </div>
          </div>
          <div class="legal-content d-flex justify-content-center mt-2">
            <b-button
              v-b-modal.address-modal
              variant="success"
              @click="prepareNewAddress"
            >
              <feather-icon
                icon="PlusIcon"
                size="18"
                class="mr-1"
              />
              {{ userAddresses.length ? $t('checkout.address.addAnother') : $t('checkout.address.add') }}
            </b-button>
          </div>
        </b-card>
      </b-col>
      <b-col md="7">
        <b-card>
          <div class="d-flex flex-column justify-content-between h-100">
            <!-- Invoice Description: Table -->
            <div class="package-info text-center">
              <h3 class="text-left">
                {{ displayTerms.name }}
              </h3>
              <ul
                v-if="isPromotionalTrialOffer"
                class="promotional-package-content"
              >
                <li class="text-left">
                  <strong>{{ $t('checkout.promotionalOffer.fullAccess.title') }}:</strong> {{ $t('checkout.promotionalOffer.fullAccess.body') }}
                </li>
                <li class="text-left">
                  <strong>{{ $t('checkout.promotionalOffer.freeTrialMonths.title') }}:</strong> {{ $t('checkout.promotionalOffer.freeTrialMonths.body') }}
                </li>
                <li class="text-left">
                  <strong>{{ $t('checkout.promotionalOffer.transparentPricing.title') }}:</strong> {{ $t('checkout.promotionalOffer.transparentPricing.prefix') }} <strong>{{ $t('checkout.promotionalOffer.transparentPricing.priceClause', { net: formattedPromotionalNet, gross: formattedPromotionalGross }) }}</strong> {{ $t('checkout.promotionalOffer.transparentPricing.suffix') }}
                </li>
                <li class="text-left">
                  <strong>{{ $t('checkout.promotionalOffer.noRisk.title') }}:</strong> {{ $t('checkout.promotionalOffer.noRisk.body') }}
                </li>
                <li class="text-left">
                  <strong>{{ $t('checkout.promotionalOffer.noCommitment.title') }}:</strong> {{ $t('checkout.promotionalOffer.noCommitment.body') }}
                </li>
              </ul>
              <ul v-else>
                <li class="text-left font-weight-bold">
                  {{ $t('All Access') }}
                </li>
                <li class="text-left font-weight-bold">
                  {{ $t('Aylık toplam') }}: {{ formattedMonthlyGross }}
                </li>
                <li class="text-left font-weight-bold">
                  {{ $t('{count} aylık ödeme dönemi', { count: offerRecurrenceCount }) }}
                </li>
              </ul>
            </div>
            <div
              v-if="total && total.subTotal > 0"
              class="invoice-description h-100"
            >
              <div class="price-table d-flex justify-content-between h-100 m-1 w-100">
                <div class="ali d-flex flex-column justify-content-between w-100 m-1">
                  <div class="table-row">
                    <div class="sub-total">
                      {{ $t("Sub Total") }}
                    </div>
                    <div class="sub-total-p">
                      {{ currencyParser(total.subTotal) }}
                    </div>
                  </div>
                  <div class="table-row">
                    <div class="price-per-sub">
                      {{ $t("Per Client") }}
                    </div>
                    <div class="price-per-p">
                      {{ currencyParser(total.subTotal / total.amount) }} (+{{ $t('VAT') }})
                    </div>
                  </div>
                  <div class="table-row">
                    <div class="discount">
                      {{ $t("Discount") }}
                    </div>
                    <div class="discount-p">
                      {{ currencyParser(total.price - total.paidPrice) }} - %{{ total.totaldiscountRate.toFixed(2) }}
                    </div>
                  </div>
                  <div class="table-row">
                    <div class="tax">
                      {{ $t("Tax") }}
                    </div>
                    <div class="tax-p">
                      {{ currencyParser(total.tax) }}
                    </div>
                  </div>
                  <div class="table-row">
                    <div class="total">
                      {{ $t("Total") }}
                    </div>
                    <div class="total-p">
                      {{ currencyParser(total.paidPrice) }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="proceed-payment m-2">
              <validation-observer ref="check">
                <b-col md="12">
                  <validation-provider
                    :name="$t('check')"
                    rules="required"
                  >
                    <b-form-group
                      :label="$t('Terms and Conditions')"
                      label-for="terms"
                    >
                      <b-alert
                        v-if="freeAccessActive"
                        show
                        variant="warning"
                      >
                        {{ $t('freeAccess.earlyPurchaseNotice') }}
                      </b-alert>
                      <b-form-checkbox
                        v-model="termCheck"
                        name="terms"
                      >
                        <b-link @click="preinformtextF">
                          {{ $t('checkout.subscription.preInformation') }}
                        </b-link>,
                        <b-link @click="preinformtextF">
                          {{ $t('checkout.subscription.serviceAgreement') }}
                        </b-link>
                        {{ $t('checkout.subscription.consentAnd') }}
                        <b-link :to="{ name: 'legal-hub' }">
                          {{ $t('checkout.subscription.legalInformation') }}
                        </b-link>{{ $t('checkout.subscription.consentSuffix') }}
                      </b-form-checkbox>
                    </b-form-group>
                  </validation-provider>
                </b-col>
              </validation-observer>
              <b-alert
                v-if="offerChanged"
                variant="warning"
                show
                class="mb-2"
              >
                <p class="mb-1">
                  {{ $t('Seçtiğiniz abonelik seçeneği değişti. Güncel bilgileri inceleyip yeniden seçim yapın.') }}
                </p>
                <b-button
                  size="sm"
                  variant="outline-warning"
                  @click="$emit('offer-changed')"
                >
                  {{ $t('Abonelik Seçeneklerine Dön') }}
                </b-button>
              </b-alert>
              <b-button
                variant="primary"
                :disabled="checkoutActionDisabled"
                class="btn-block"
                @click.prevent="goPayment"
              >{{ checkoutActionLabel }}</b-button>
            </div>
            <div>
              <b-modal
                id="IframeModal"
                size="lg"
                no-enforce-focus
                hide-footer
                :title="$t('checkout.resume.modalTitle')"
                @shown="mountCheckoutForm"
                @hidden="handleCheckoutModalHidden"
              >
                <b-alert
                  v-if="checkoutResumeNotice && checkoutPhase !== 'mount-failed'"
                  variant="info"
                  show
                  class="mb-2"
                >
                  {{ $t('checkout.resume.inMemoryAvailable') }}
                </b-alert>
                <b-alert
                  v-if="checkoutPhase === 'mount-failed'"
                  variant="danger"
                  show
                  class="mb-2"
                >
                  <h4 class="alert-heading">
                    {{ $t('checkout.resume.mountFailedTitle') }}
                  </h4>
                  <p>{{ $t('checkout.resume.mountFailedBody') }}</p>
                  <p
                    v-if="mountFailureCount >= 2"
                    class="mb-1"
                  >
                    {{ mountFailureRecoveryText }}
                  </p>
                  <b-button
                    variant="outline-danger"
                    :disabled="requestInFlight"
                    @click="retryCheckoutMount"
                  >
                    {{ $t('checkout.resume.retryMount') }}
                  </b-button>
                  <b-button
                    v-if="mountFailureCount >= 2 && checkoutSession && checkoutSession.serverResumable"
                    variant="link"
                    :disabled="requestInFlight"
                    @click="reloadCheckoutPage"
                  >
                    {{ $t('checkout.resume.reloadPage') }}
                  </b-button>
                </b-alert>
                <div
                  id="iyzipay-checkout-form-container"
                  class="responsive"
                  style="min-height: 600px;"
                />
              </b-modal>
              <!-- modal for address -->
              <div>
                <b-modal
                  id="address-modal"
                  ref="addressModal"
                  size="lg"
                  centered
                  hide-footer
                >
                  <b-row>
                    <b-col>
                      <validation-observer ref="simpleRules">
                        <b-form-group>
                          <label for="Label">Adres Etiketi</label>
                          <validation-provider
                            #default="{ errors }"
                            name="Adres Etiketi"
                            rules="required"
                          >
                            <!-- Item 5 (PM 05.08.2026): the "İş Adresim" chip the
                                 PM saw is Chrome's own saved-form suggestion, not
                                 app markup. `autocomplete="off"` stops us opting
                                 into it; the example now lives in the placeholder. -->
                            <b-form-input
                              v-model="addressLabel"
                              :state="errors.length > 0 ? false : null"
                              placeholder="Örn: İş Adresim"
                              autocomplete="off"
                            />
                            <small class="text-danger">{{ errors[0] }}</small>
                          </validation-provider>
                        </b-form-group>
                        <b-form-group>
                          <label for="city">İl</label>
                          <validation-provider
                            #default="{ errors }"
                            name="Şehir"
                            rules="required"
                          >
                            <b-form-select
                              id="city"
                              v-model="selectedCity"
                              class=""
                              name="city"
                            >
                              <b-form-select-option
                                v-for="city in cities"
                                :key="city.plate"
                                :value="city.city"
                              >
                                {{ city.city }}
                              </b-form-select-option>
                            </b-form-select>
                            <small class="text-danger">{{ errors[0] }}</small>
                          </validation-provider>
                        </b-form-group>
                        <b-form-group>
                          <label for="district">İlçe</label>
                          <validation-provider
                            #default="{ errors }"
                            name="İlçe"
                          >
                            <b-form-select
                              id="district"
                              v-model="selectedDistrict"
                              class=""
                              name="selectedDistrict"
                            >
                              <b-form-select-option
                                v-for="dist in district"
                                :key="dist"
                                :value="dist"
                              >
                                {{ dist }}
                              </b-form-select-option>
                            </b-form-select>
                            <small class="text-danger">{{ errors[0] }}</small>
                          </validation-provider>
                        </b-form-group>
                        <b-form-group>
                          <label for="Address">Adres</label>
                          <validation-provider
                            #default="{ errors }"
                            name="Adres"
                            rules="required"
                          >
                            <b-form-input
                              v-model="address"
                              :state="errors.length > 0 ? false : null"
                              placeholder="Adres"
                            />
                            <small class="text-danger">{{ errors[0] }}</small>
                          </validation-provider>
                        </b-form-group>
                        <b-form-group>
                          <label for="zipcode">Posta Kodu</label>
                          <validation-provider
                            #default="{ errors }"
                            name="Posta Kodu"
                            rules="required|digits:5"
                          >
                            <b-form-input
                              v-model="zipcode"
                              :state="errors.length > 0 ? false : null"
                              placeholder="Posta Kodu"
                              type="number"
                              max="5"
                            />
                            <small class="text-danger">{{ errors[0] }}</small>
                          </validation-provider>
                        </b-form-group>
                        <b-form-group>
                          <validation-provider
                            #default="{ errors }"
                            name="TCKN veya VKN"
                            rules="required"
                          >
                            <b-form-radio-group
                              name=""
                              class="d-flex align-content-center justify-content-around"
                            >
                              <b-form-radio
                                v-model="vknOrTckn"
                                value="tckn"
                              >
                                Bireysel Fatura
                              </b-form-radio>
                              <b-form-radio
                                v-model="vknOrTckn"
                                value="vkn"
                              >
                                Kurumsal Fatura
                              </b-form-radio>
                            </b-form-radio-group>
                            <small class="text-danger">{{ errors[0] }}</small>
                          </validation-provider>
                        </b-form-group>
                        <b-form-group>
                          <label
                            for="identificationNumber"
                          >{{ vknOrTckn == 'vkn' ? 'Vergi Numarası' : 'TC Kimlik No' }}</label>
                          <validation-provider
                            #default="{ errors }"
                            name="TCKN veya Vergi Numarası"
                            rules="required|min:10|max:11"
                          >
                            <b-form-input
                              v-model="identificationNumber"
                              :state="errors.length > 0 ? false : null"
                              placeholder="TCKN / Vergi No"
                              type="number"
                              max="11"
                            />
                            <small class="text-danger">{{ errors[0] }}</small>
                          </validation-provider>
                        </b-form-group>
                        <b-form-group v-if="vknOrTckn == 'vkn' ? true : false">
                          <label for="taxDept">Vergi Dairesi</label>
                          <validation-provider
                            #default="{ errors }"
                            name="Vergi Dairesi"
                            :rules="vknOrTckn == 'vkn' ? 'required' : ''"
                          >
                            <b-form-input
                              v-model="taxDept"
                              :state="errors.length > 0 ? false : null"
                              placeholder="Vergi Dairesi"
                            />
                            <small class="text-danger">{{ errors[0] }}</small>
                          </validation-provider>
                        </b-form-group>
                        <b-button
                          variant="primary"
                          type="submit"
                          @click.prevent="validationForm"
                        >
                          {{ $t("Save") }}
                        </b-button>
                      </validation-observer>
                    </b-col>
                  </b-row>
                </b-modal>
              </div>
              <!-- modal for terms -->
              <div>
                <b-modal
                  ref="preinformtextF"
                  size="lg"
                  centered
                  hide-footer
                >
                  <b-card>
                    <preinformtext :informations="informations" />
                  </b-card>
                </b-modal>
              </div>
            </div>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { isFreeAccessActive } from '@/libs/freeAccess'
/* import feather icon */
import FeatherIcon from '@core/components/feather-icon/FeatherIcon.vue'
import { required } from '@validations'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import {
  ValidationProvider, ValidationObserver, localize, extend,
} from 'vee-validate'
// import {t as translate} from "@/libs/i18n";
// import VVLocale from `vee-validate/dist/locale/${i18n.locale.split('-')[0]}.json`;
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BFormSelectOption,
  BButton,
  BModal,
  BFormRadio,
  BFormCheckbox,
  BCard,
  VBTooltip,
  VBModal,
  BLink,
  BAlert,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import axios from '@axios'
import {
  customerCommercialTerms,
  formatTry,
  normalizeCommercialOffer,
  sameCommercialOffer,
} from '@/libs/subscriptionCommercial'
import {
  fetchSubscriptionStanding,
  invalidateSubscriptionStanding,
} from '@/libs/subscriptionStanding'
import { OTP_ERROR_KEYS_BY_CODE, OTP_ERROR_KEYS_BY_REASON_400515 } from '@/libs/otpI18nKeys'
import {
  evaluatePendingCheckoutSession,
  normalizePendingCheckoutSession,
  pendingCheckoutRemainingMs,
} from '@/libs/pendingCheckoutSession'
import { cleanupIyzicoCheckout, mountIyzicoCheckout } from '@/utils/iyzicoCheckout'
import preinformtext from './preinformtext.vue'

const cities = require('./turkey')
// import tr from "vee-validate/dist/locale/tr.json"

// localize({
//   tr
// });
// localize("tr");

const {
  axiosRoutes: {
    payment: paymentPath, address: addressPath, user: userPath,
  },
} = require('../../../../G_CONFIG')

const CURRENT_SUBSCRIPTION_STATUSES = ['TRIAL', 'ACTIVE', 'PAST_DUE']
const REVIEW_STATES = ['not-started', 'active', 'completed', 'not-applicable']
const RECOVERY_WAIT_MAX_MS = 15000

const checkoutStatusPreflight = (standing, selectedOffer, reviewStartsOnSubscription) => {
  const currentOffer = normalizeCommercialOffer(standing && standing.offer)
  const complete = Boolean(
    standing
    && standing.contractComplete === true
    && typeof standing.subscriptionStatus === 'string'
    && typeof standing.hasSubscription === 'boolean'
    && standing.approvalReview
    && REVIEW_STATES.includes(standing.approvalReview.state)
    && currentOffer,
  )
  if (!complete) {
    return {
      ok: false,
      matches: false,
      outcome: 'status-unavailable',
      currentOffer: null,
      standing,
    }
  }

  const currentReviewStartsOnSubscription = standing.approvalReason === 'pending'
    && standing.approvalReview.state === 'not-started'
  let outcome = null
  if (CURRENT_SUBSCRIPTION_STATUSES.includes(standing.subscriptionStatus)) {
    outcome = 'current-subscription'
  } else if (standing.accountBlocked) {
    outcome = 'account-blocked'
  } else if (!standing.approvalStanding.allowed) {
    outcome = ['approval-missing', 'approval-rejected'].includes(standing.approvalReason)
      ? standing.approvalReason
      : 'approval-denied'
  } else if (standing.approvalReason === 'pending'
    && Number(currentOffer.trialPeriodDays) <= 0) {
    outcome = 'approval-required-for-paid-plan'
  } else if (currentOffer.blocked) {
    outcome = 'current-access-remains'
  }

  const matches = outcome === null
    && sameCommercialOffer(selectedOffer, currentOffer)
    && currentReviewStartsOnSubscription === reviewStartsOnSubscription
  return {
    ok: true,
    matches,
    outcome: outcome || (matches ? null : 'offer-changed'),
    currentOffer,
    currentReviewStartsOnSubscription,
    standing,
  }
}

export default {
  directives: {
    Ripple,
    'b-tooltip': VBTooltip,
    'b-modal': VBModal,
  },
  components: {
    preinformtext,
    BCard,
    BFormCheckbox,
    ValidationObserver,
    ValidationProvider,
    BFormRadio,
    FeatherIcon,
    BModal,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
    BFormSelect,
    BFormSelectOption,
    BButton,
    BLink,
    BAlert,
  },
  props: {
    total: {
      type: Object,
      required: true,
    },
    planKey: {
      type: String,
      default: null,
    },
    selectedOffer: {
      type: Object,
      default: null,
    },
    freeAccess: {
      type: Object,
      default: null,
    },
    reviewStartsOnSubscription: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      standing: null,
      render: true,
      addressSaved: false,
      userInfo: null,
      selectedAdressIndex: 0,
      selectedAddress: {
        label: '',
        city: '',
        district: '',
        country: '',
        address: '',
        zipcode: '',
        identificationNumber: '',
        taxDept: '',
      },
      userAddress: '',
      checkoutSession: null,
      checkoutPhase: 'idle',
      checkoutMountGeneration: 0,
      checkoutResumeNotice: false,
      mountFailureCount: 0,
      operationGeneration: 0,
      recoveryWaitActive: false,
      recoveryWaitTimer: null,
      userAddresses: [],
      /* selected: null, */
      cities,
      selectedCity: '',
      district: [],
      selectedDistrict: '',
      formIndex: 0,
      firstName: '',
      companyName: '',
      Email: '',
      Phone: '',
      taxNumber: '',
      taxDepartment: '',
      address: '',
      zipcode: '',
      addressLabel: '',
      termCheck: false,
      identificationNumber: '',
      taxDept: '',
      addressId: '',
      informations: {
        name: '',
        address: '',
        phone: '',
        email: '',
        taxNumber: '',
        taxDepartment: '',
      },
      // isFilled: false,
      required,
      vknOrTckn: 'tckn',
      offer: normalizeCommercialOffer(this.selectedOffer),
      offerChanged: false,
      requestInFlight: false,
      currencyParser: new Intl.NumberFormat('tr-TR', {
        style: 'currency',
        currency: 'TRY',
      }).format,
    }
  },
  computed: {
    freeAccessActive() { return isFreeAccessActive(this.standing ? this.standing.freeAccess : this.freeAccess) },
    displayTerms() {
      // L9: same server-resolved pricing the offer itself carries, so the
      // checkout disclosure cannot quote a different figure from the page the
      // customer chose the plan on.
      return customerCommercialTerms(this.offer)
    },
    isPromotionalTrialOffer() {
      const trialPeriodDays = Number(this.offer && this.offer.trialPeriodDays)
      return Boolean(this.offer
        && this.offer.planKey === 'launch_promo'
        && this.offer.promotional
        && trialPeriodDays === 90)
    },
    offerRecurrenceCount() {
      const recurrenceCount = Number(this.offer && this.offer.recurrenceCount)
      return Number.isFinite(recurrenceCount) ? recurrenceCount : 0
    },
    formattedMonthlyGross() {
      return formatTry(this.displayTerms.grossPrice, this.displayTerms.currency)
    },
    // Sourced from displayTerms (not hardcoded) so a plan re-versioning can't
    // strand a stale price in the promotional bullet copy.
    formattedPromotionalNet() {
      return formatTry(this.displayTerms.netPrice, this.displayTerms.currency)
    },
    formattedPromotionalGross() {
      return formatTry(this.displayTerms.grossPrice, this.displayTerms.currency)
    },
    checkoutActionDisabled() {
      return !this.termCheck
        || this.requestInFlight
        || this.recoveryWaitActive
        || this.offerChanged
    },
    checkoutActionLabel() {
      if (this.requestInFlight) return this.$t('checkout.resume.processing')
      if (this.recoveryWaitActive) return this.$t('checkout.resume.recoveryWait')
      if (this.checkoutSession
        && evaluatePendingCheckoutSession(
          this.checkoutSession,
          this.offer && this.offer.planKey,
        ) === 'resumable') {
        return this.$t('checkout.resume.continue')
      }
      return this.$t('Proceed to Payment')
    },
    mountFailureRecoveryText() {
      if (!this.checkoutSession) return ''
      if (this.checkoutSession.serverResumable) return this.$t('checkout.resume.reloadRecovery')
      const timing = this.pendingTimingParams(this.checkoutSession)
      if (timing) return this.$t('checkout.resume.unavailableUntil', timing)
      return this.$t('checkout.resume.localOnlyRecovery')
    },
  },
  watch: {
    selectedCity() {
      this.syncDistrictOptions()
    },
    selectedAdressIndex() {
      this.getAddress()
    },
  },
  async created() {
    extend('max', {
      validate(value, { length }) {
        return value.length <= length
      },
      params: ['length'],
      message: '{_field_} {length} karakteri geçemez.',
    })
    localize('tr')
    this.cities = cities
    if (!this.offer || this.offer.blocked || this.offer.planKey !== this.planKey) {
      this.offerChanged = true
    }
    // Removed old pricing calculation endpoint call as it now initiates actual Iyzico checkout
    axios.get(userPath.my).then(res => {
      this.userInfo = res.data
    })
    this.getAddresses()
  },
  beforeDestroy() {
    this.operationGeneration += 1
    if (this.recoveryWaitTimer) clearTimeout(this.recoveryWaitTimer)
    this.recoveryWaitTimer = null
    this.recoveryWaitActive = false
    this.requestInFlight = false
    this.cleanupCheckoutDom()
  },

  methods: {
    beginCheckoutOperation() {
      this.operationGeneration += 1
      return this.operationGeneration
    },
    isCheckoutOperationCurrent(generation) {
      return generation === this.operationGeneration
    },
    async loadSubscriptionStatus(generation = null) {
      try {
        const standing = await fetchSubscriptionStanding({ forceRefresh: true })
        if (generation === null || this.isCheckoutOperationCurrent(generation)) this.standing = standing
        const preflight = checkoutStatusPreflight(
          standing,
          this.offer,
          this.reviewStartsOnSubscription,
        )
        if (!preflight.matches
          && (generation === null || this.isCheckoutOperationCurrent(generation))) {
          this.offerChanged = true
        }
        return preflight
      } catch (error) {
        return {
          ok: false,
          matches: false,
          outcome: 'status-unavailable',
          currentOffer: null,
          standing: null,
        }
      }
    },
    async handlePreflightMismatch(preflight, generation = null) {
      if (generation !== null && !this.isCheckoutOperationCurrent(generation)) return
      const outcome = preflight && preflight.outcome
      if (!outcome || outcome === 'offer-changed') {
        await this.showOfferChangedDialog(generation)
        return
      }

      this.offerChanged = true
      let title = this.$t('Payment could not be initialized')
      let text = this.$t('Your application status changed. Review its current status to continue.')
      let returnToPricing = false
      let goApplication = false

      if (outcome === 'current-subscription') {
        title = this.$t('Mevcut Aboneliğiniz Bulunuyor')
        text = this.$t(OTP_ERROR_KEYS_BY_CODE[400513])
        returnToPricing = true
      } else if (outcome === 'current-access-remains') {
        title = this.$t('Mevcut Abonelik Erişiminiz Devam Ediyor')
        text = this.$t(OTP_ERROR_KEYS_BY_CODE[400513])
        returnToPricing = true
      } else if (outcome === 'account-blocked') {
        title = this.$t('Hesabınız İçin Destek Gerekiyor')
        text = this.$t(OTP_ERROR_KEYS_BY_CODE[403013])
        returnToPricing = true
      } else if (outcome === 'approval-required-for-paid-plan') {
        text = this.$t(OTP_ERROR_KEYS_BY_REASON_400515[outcome])
        returnToPricing = true
      } else if (['approval-missing', 'approval-rejected'].includes(outcome)) {
        text = this.$t(OTP_ERROR_KEYS_BY_REASON_400515[outcome])
        goApplication = true
      } else if (outcome === 'approval-denied') {
        goApplication = true
      }

      await this.$swal({
        title,
        text,
        icon: 'warning',
        confirmButtonText: this.$t('Ok'),
        customClass: { confirmButton: 'btn btn-primary' },
        buttonsStyling: false,
      })
      if (generation !== null && !this.isCheckoutOperationCurrent(generation)) return
      if (goApplication) {
        this.$router.push({ name: 'account-settings' }).catch(() => {})
      } else if (returnToPricing) {
        this.$emit('offer-changed')
      }
    },
    preinformtextF() {
      const user = this.userInfo || {}
      const selectedAddress = this.userAddresses[this.selectedAdressIndex] || {}
      this.informations.name = user.name || ''
      this.informations.address = selectedAddress.address || ''
      this.informations.phone = user.phone || ''
      this.informations.email = user.email || ''
      this.informations.taxNumber = selectedAddress.identificationNumber || ''
      this.informations.taxDepartment = selectedAddress.taxDept || ''
      this.$refs.preinformtextF.show()
    },
    getAddresses(deleted = false) {
      axios.get(addressPath.getAll).then(res => {
        this.userAddresses = res.data
        if (deleted) this.selectedAdressIndex = this.userAddresses.length > 0 ? this.userAddresses.length - 1 : 0
      })
    },
    editAddress(index) {
      this.selectedAdressIndex = index
      this.addressLabel = this.userAddresses[index].label
      this.selectedCity = this.userAddresses[index].city
      this.selectedDistrict = this.userAddresses[index].district || ''
      this.syncDistrictOptions()
      this.address = this.userAddresses[index].address
      this.zipcode = this.userAddresses[index].zipcode
      this.identificationNumber = this.userAddresses[index].identificationNumber
      this.taxDept = this.userAddresses[index].taxDept
      this.addressId = Reflect.get(this.userAddresses[index], '_id')
      this.$refs.addressModal.show()
    },
    prepareNewAddress() {
      this.resetAddressForm()
    },
    resetAddressForm() {
      this.addressLabel = ''
      this.selectedCity = ''
      this.selectedDistrict = ''
      this.district = []
      this.address = ''
      this.zipcode = ''
      this.identificationNumber = ''
      this.taxDept = ''
      this.addressId = ''
    },
    syncDistrictOptions() {
      const city = this.cities.find(item => item.city === this.selectedCity)
      this.district = city && Array.isArray(city.district) ? city.district : []
      if (!this.district.includes(this.selectedDistrict)) this.selectedDistrict = ''
    },
    deleteAddress(index) {
      this.$swal({
        title: this.$t('Are you sure to delete this address?'),
        text: this.$t("You won't be able to revert this!"),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$t('Yes, delete it!'),
        cancelButtonText: this.$t('No, cancel!'),
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          const addressId = Reflect.get(this.userAddresses[index], '_id')
          axios.delete(addressPath.delete + addressId).then(() => {
            this.getAddresses(true)
            // this.selectedAdressIndex = this.userAddresses.length;
            this.resetAddressForm()
          })
          this.$swal({
            icon: 'success',
            title: this.$t('Deleted!'),
            text: this.$t('Your address has been deleted.'),
            customClass: {
              confirmButton: 'btn btn-success',
            },
          })
        }
      })
    },
    postAddress() {
      const newAddressPattern = {
        label: this.addressLabel,
        city: this.selectedCity,
        district: this.selectedDistrict,
        country: 'Türkiye',
        address: this.address,
        zipcode: this.zipcode,
        identificationNumber: this.identificationNumber,
        taxDept: this.taxDept,
      }
      if (this.addressId) {
        axios.put(addressPath.update + this.addressId, newAddressPattern).then(() => {
          this.getAddresses()
          this.resetAddressForm()

          this.$swal({
            title: this.$t('checkout.address.updated'),
            icon: 'success',
            confirmButtonText: this.$t('Ok'),
            timer: 3000,
            customClass: {
              confirmButton: 'btn btn-primary',
            },
            buttonsStyling: false,
          })
        })
      } else {
        axios
          .post(addressPath.new, newAddressPattern)
          .then(() => {
            this.getAddresses()
            this.selectedAdressIndex = this.userAddresses.length
            this.resetAddressForm()

            this.$swal({
              title: this.$t('checkout.address.created'),
              icon: 'success',
              confirmButtonText: this.$t('Ok'),
              timer: 3000,
              customClass: {
                confirmButton: 'btn btn-primary',
              },
              buttonsStyling: false,
            })
          })
          .catch(() => {})
      }
    },
    async goPayment() {
      const selectedAddress = this.userAddresses[this.selectedAdressIndex]
      if (!selectedAddress) {
        await this.$swal({
          title: this.$t('Please add an address'),
          icon: 'error',
          confirmButtonText: this.$t('Ok'),
          timer: 3000,
          customClass: { confirmButton: 'btn btn-primary' },
          buttonsStyling: false,
        })
        return
      }
      if (!this.termCheck
        || this.requestInFlight
        || this.recoveryWaitActive
        || this.offerChanged
        || !this.offer
        || this.offer.planKey !== this.planKey) return

      const generation = this.beginCheckoutOperation()
      const budget = {
        initializations: 0,
        resumes: 0,
        expiredInitializations: 0,
      }
      this.requestInFlight = true
      try {
        const memoryState = evaluatePendingCheckoutSession(
          this.checkoutSession,
          this.offer.planKey,
        )
        if (memoryState === 'plan-mismatch') {
          await this.showPendingPlanMismatch(this.checkoutSession, generation)
          return
        }
        if (['expired', 'invalid'].includes(memoryState)) this.discardCheckoutSession()

        const preflight = await this.loadSubscriptionStatus(generation)
        if (!this.isCheckoutOperationCurrent(generation)) return
        if (!preflight.ok) {
          await this.showPreflightUnavailable(generation)
          return
        }
        if (!preflight.matches) {
          this.discardCheckoutSession()
          await this.handlePreflightMismatch(preflight, generation)
          return
        }

        if (evaluatePendingCheckoutSession(
          this.checkoutSession,
          this.offer.planKey,
        ) === 'resumable') {
          this.showCheckoutModal(generation, true)
          return
        }

        await this.initializeCheckout(generation, budget)
      } finally {
        if (this.isCheckoutOperationCurrent(generation)
          && !(this.checkoutPhase === 'open' && this.checkoutSession)) this.requestInFlight = false
      }
    },
    async initializeCheckout(generation, budget, expiredRetry = false) {
      const requestBudget = budget
      if (!this.isCheckoutOperationCurrent(generation) || requestBudget.initializations >= 2) return false
      if (expiredRetry && requestBudget.expiredInitializations >= 1) return false
      if (expiredRetry) requestBudget.expiredInitializations += 1
      requestBudget.initializations += 1
      this.checkoutPhase = 'initializing'

      const selectedAddress = this.userAddresses[this.selectedAdressIndex]
      if (!selectedAddress) return false
      try {
        const res = await axios.post(paymentPath.new, {
          addressLabel: selectedAddress.label,
          planKey: this.offer.planKey,
        }, { suppressErrorToast: true })
        if (!this.isCheckoutOperationCurrent(generation)) return false

        const session = normalizePendingCheckoutSession(res.data, {
          source: 'initialized',
          receivedAt: Date.now(),
        })
        if (!session) {
          await this.showPaymentInitializationFailure(generation)
          return false
        }
        const state = evaluatePendingCheckoutSession(session, this.offer.planKey)
        if (state === 'plan-mismatch') {
          await this.showPendingPlanMismatch(session, generation)
          return false
        }
        if (state !== 'resumable') {
          await this.showPaymentInitializationFailure(generation)
          return false
        }

        this.checkoutSession = session
        this.mountFailureCount = 0
        this.showCheckoutModal(generation, false)
        return true
      } catch (err) {
        if (!this.isCheckoutOperationCurrent(generation)) return false
        return this.handlePaymentError(err, generation, budget)
      }
    },
    async resumeCheckout(generation, budget) {
      const requestBudget = budget
      if (!this.isCheckoutOperationCurrent(generation) || requestBudget.resumes >= 1) {
        await this.showPendingCheckoutWarning(generation)
        return false
      }
      requestBudget.resumes += 1
      this.checkoutPhase = 'resuming'
      try {
        const res = await axios.post(paymentPath.resume, {
          planKey: this.offer.planKey,
        }, { suppressErrorToast: true })
        if (!this.isCheckoutOperationCurrent(generation)) return false
        return this.handleResumeResponse(res.data || {}, generation, budget)
      } catch (err) {
        if (!this.isCheckoutOperationCurrent(generation)) return false
        const data = (err && err.response && err.response.data) || {}
        if (Number(data.errorCode) === 400512) {
          return this.handlePendingCheckoutConflict(err, generation, budget)
        }
        await this.showPendingCheckoutWarning(generation)
        return false
      }
    },
    async handleResumeResponse(data, generation, budget) {
      if (!this.isCheckoutOperationCurrent(generation)) return false
      if (data.state === 'resumable') {
        const session = normalizePendingCheckoutSession(data, {
          source: 'resumed',
          receivedAt: Date.now(),
        })
        if (!session) {
          await this.showPendingCheckoutWarning(generation)
          return false
        }
        const state = evaluatePendingCheckoutSession(session, this.offer.planKey)
        if (state === 'plan-mismatch') {
          await this.showPendingPlanMismatch(session, generation)
          return false
        }
        if (state === 'expired') return this.initializeAfterExpiredResume(generation, budget)
        if (state !== 'resumable') {
          await this.showPendingCheckoutWarning(generation)
          return false
        }
        this.checkoutSession = session
        this.mountFailureCount = 0
        this.showCheckoutModal(generation, true)
        return true
      }
      if (data.state === 'expired') return this.initializeAfterExpiredResume(generation, budget)
      if (data.state === 'plan-mismatch') {
        await this.showPendingPlanMismatch(data, generation)
        return false
      }
      if (data.state === 'unavailable') {
        await this.showResumeUnavailable(data, generation)
        return false
      }
      if (['none', 'not-resumable'].includes(data.state)) {
        return this.refreshStandingAfterNonResumable(generation)
      }

      this.discardCheckoutSession()
      await this.showPendingCheckoutWarning(generation)
      return false
    },
    async refreshStandingAfterNonResumable(generation) {
      if (!this.isCheckoutOperationCurrent(generation)) return false
      this.discardCheckoutSession()
      const preflight = await this.loadSubscriptionStatus(generation)
      if (!this.isCheckoutOperationCurrent(generation)) return false
      if (!preflight.ok) {
        await this.showPreflightUnavailable(generation)
        return false
      }
      if (!preflight.matches) {
        await this.handlePreflightMismatch(preflight, generation)
        return false
      }
      await this.showPendingCheckoutWarning(generation)
      return false
    },
    async initializeAfterExpiredResume(generation, budget) {
      if (!this.isCheckoutOperationCurrent(generation) || budget.expiredInitializations >= 1) {
        await this.showPendingCheckoutWarning(generation)
        return false
      }
      this.discardCheckoutSession()
      const preflight = await this.loadSubscriptionStatus(generation)
      if (!this.isCheckoutOperationCurrent(generation)) return false
      if (!preflight.ok) {
        await this.showPreflightUnavailable(generation)
        return false
      }
      if (!preflight.matches) {
        await this.handlePreflightMismatch(preflight, generation)
        return false
      }
      return this.initializeCheckout(generation, budget, true)
    },
    async showOfferChangedDialog(generation = null) {
      if (generation !== null && !this.isCheckoutOperationCurrent(generation)) return
      this.offerChanged = true
      this.checkoutPhase = 'offer-changed'
      await this.$swal({
        title: this.$t('Abonelik Seçeneği Güncellendi'),
        text: this.$t('Seçtiğiniz abonelik seçeneği değişti. Güncel bilgileri inceleyip yeniden seçim yapın.'),
        icon: 'warning',
        confirmButtonText: this.$t('Ok'),
        customClass: { confirmButton: 'btn btn-primary' },
        buttonsStyling: false,
      })
    },
    async handlePaymentError(err, generation, budget) {
      if (!this.isCheckoutOperationCurrent(generation)) return false
      const data = (err && err.response && err.response.data) || {}
      const code = Number(data.errorCode)

      if ([400511, 400512, 400513, 400514, 400515, 403013].includes(code)) {
        invalidateSubscriptionStanding()
      }
      if ([400511, 400513].includes(code)) {
        this.discardCheckoutSession()
        await this.loadSubscriptionStatus(generation)
        if (!this.isCheckoutOperationCurrent(generation)) return false
        await this.handlePreflightMismatch({
          outcome: code === 400511 ? 'current-subscription' : 'current-access-remains',
        }, generation)
        return false
      }
      if (code === 400512) return this.handlePendingCheckoutConflict(err, generation, budget)
      if (code === 400514) {
        this.discardCheckoutSession()
        await this.loadSubscriptionStatus(generation)
        if (!this.isCheckoutOperationCurrent(generation)) return false
        await this.showOfferChangedDialog(generation)
        return false
      }
      if (code === 400515) await this.loadSubscriptionStatus(generation)
      if (!this.isCheckoutOperationCurrent(generation)) return false

      const reasonKey = code === 400515 ? OTP_ERROR_KEYS_BY_REASON_400515[data.reason] : null
      const mappedKey = reasonKey || OTP_ERROR_KEYS_BY_CODE[code]
      const text = mappedKey ? this.$t(mappedKey) : (data.message || data.error || '')
      const goApplication = code === 400515
        && ['approval-missing', 'approval-rejected'].includes(data.reason)
      await this.$swal({
        title: this.$t('Payment could not be initialized'),
        text,
        icon: 'error',
        confirmButtonText: this.$t('Ok'),
        customClass: { confirmButton: 'btn btn-primary' },
        buttonsStyling: false,
      })
      if (this.isCheckoutOperationCurrent(generation) && goApplication) {
        this.$router.push({ name: 'account-settings' }).catch(() => {})
      }
      return false
    },
    async handlePendingCheckoutConflict(err, generation, budget) {
      if (!this.isCheckoutOperationCurrent(generation)) return false
      const response = (err && err.response) || {}
      const data = response.data || {}
      if (['checkout-recovery', 'checkout-race'].includes(data.reason)) {
        await this.enterRecoveryWait(data, response.headers || {}, generation)
        return false
      }
      if (data.reason === 'checkout-active' || !data.reason) {
        return this.resumeCheckout(generation, budget)
      }
      await this.showPendingCheckoutWarning(generation)
      return false
    },
    async enterRecoveryWait(data, headers, generation) {
      if (!this.isCheckoutOperationCurrent(generation)) return
      const headerDelay = Number(headers['retry-after'] || headers['Retry-After'])
      const bodyDelay = Number(data.retryAfterSeconds)
      const seconds = Number.isFinite(bodyDelay) && bodyDelay > 0 ? bodyDelay : headerDelay
      const waitMs = Math.min(
        RECOVERY_WAIT_MAX_MS,
        Math.max(1000, (Number.isFinite(seconds) && seconds > 0 ? seconds : 1) * 1000),
      )
      if (this.recoveryWaitTimer) clearTimeout(this.recoveryWaitTimer)
      this.checkoutPhase = 'recovery-wait'
      this.recoveryWaitActive = true
      this.recoveryWaitTimer = setTimeout(() => {
        if (!this.isCheckoutOperationCurrent(generation)) return
        this.recoveryWaitTimer = null
        this.recoveryWaitActive = false
        this.checkoutPhase = 'idle'
      }, waitMs)
      await this.$swal({
        title: this.$t('Abonelik Ödeme İşlemi Devam Ediyor'),
        text: this.$t('checkout.resume.recoveryWait'),
        icon: 'warning',
        confirmButtonText: this.$t('Ok'),
        customClass: { confirmButton: 'btn btn-primary' },
        buttonsStyling: false,
      })
    },
    async showPreflightUnavailable(generation) {
      if (!this.isCheckoutOperationCurrent(generation)) return
      await this.$swal({
        title: this.$t('Abonelik bilgileri doğrulanamadı'),
        text: this.$t('Devam etmeden önce abonelik bilgilerini yeniden yükleyin.'),
        icon: 'error',
        confirmButtonText: this.$t('Ok'),
      })
    },
    async showPaymentInitializationFailure(generation) {
      if (!this.isCheckoutOperationCurrent(generation)) return
      this.checkoutPhase = 'idle'
      await this.$swal({
        title: this.$t('Payment could not be initialized'),
        icon: 'error',
        confirmButtonText: this.$t('Ok'),
        timer: 3000,
        customClass: { confirmButton: 'btn btn-primary' },
        buttonsStyling: false,
      })
    },
    async showPendingCheckoutWarning(generation) {
      if (!this.isCheckoutOperationCurrent(generation)) return
      this.checkoutPhase = 'idle'
      await this.$swal({
        title: this.$t('Abonelik Ödeme İşlemi Devam Ediyor'),
        text: this.$t('Abonelik ödeme işleminiz zaten devam ediyor. Açık ödeme penceresini tamamlayın veya kısa süre sonra yeniden deneyin.'),
        icon: 'warning',
        confirmButtonText: this.$t('Ok'),
        customClass: { confirmButton: 'btn btn-primary' },
        buttonsStyling: false,
      })
    },
    async showResumeUnavailable(data, generation) {
      if (!this.isCheckoutOperationCurrent(generation)) return
      this.discardCheckoutSession()
      const timing = this.pendingTimingParams({ ...data, receivedAt: Date.now() })
      await this.$swal({
        title: this.$t('Abonelik Ödeme İşlemi Devam Ediyor'),
        text: timing
          ? this.$t('checkout.resume.unavailableUntil', timing)
          : this.$t('Abonelik ödeme işleminiz zaten devam ediyor. Açık ödeme penceresini tamamlayın veya kısa süre sonra yeniden deneyin.'),
        icon: 'warning',
        confirmButtonText: this.$t('Ok'),
        customClass: { confirmButton: 'btn btn-primary' },
        buttonsStyling: false,
      })
    },
    async showPendingPlanMismatch(pending, generation) {
      if (!pending || !this.isCheckoutOperationCurrent(generation)) return
      const timing = this.pendingTimingParams({ ...pending, receivedAt: pending.receivedAt || Date.now() })
      const timingText = timing ? ` ${this.$t('checkout.resume.unavailableUntil', timing)}` : ''
      this.checkoutSession = null
      this.checkoutResumeNotice = false
      this.offerChanged = true
      this.checkoutPhase = 'offer-changed'
      await this.$swal({
        title: this.$t('Abonelik Seçeneği Güncellendi'),
        text: `${this.$t('checkout.resume.planMismatch', { planKey: pending.planKey })}${timingText}`,
        icon: 'warning',
        confirmButtonText: this.$t('Abonelik Seçeneklerine Dön'),
        customClass: { confirmButton: 'btn btn-primary' },
        buttonsStyling: false,
      })
      if (this.isCheckoutOperationCurrent(generation)) this.$emit('offer-changed')
    },
    pendingTimingParams(value) {
      if (!value || !value.checkoutExpiresAt || !value.serverTime) return null
      const timing = value.expiryMode ? value : {
        expiryMode: 'known',
        checkoutExpiresAt: value.checkoutExpiresAt,
        serverTime: value.serverTime,
        receivedAt: value.receivedAt,
      }
      const remainingMs = pendingCheckoutRemainingMs(timing)
      const expiresAt = Date.parse(value.checkoutExpiresAt)
      if (remainingMs === null || !Number.isFinite(expiresAt)) return null
      const locale = (this.$i18n && this.$i18n.locale) || 'tr-TR'
      const formattedExpiry = new Intl.DateTimeFormat(locale, {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      }).format(new Date(expiresAt))
      return {
        expiresAt: formattedExpiry,
        remaining: this.$t('checkout.resume.minutesRemaining', {
          count: Math.max(1, Math.ceil(remainingMs / 60000)),
        }),
      }
    },
    showCheckoutModal(generation, resumed) {
      if (!this.isCheckoutOperationCurrent(generation) || !this.checkoutSession) return
      this.checkoutPhase = 'open'
      this.checkoutMountGeneration = generation
      this.checkoutResumeNotice = resumed
      this.$bvModal.show('IframeModal')
    },
    async mountCheckoutForm() {
      const generation = this.checkoutMountGeneration
      if (!this.isCheckoutOperationCurrent(generation) || !this.checkoutSession) return false
      const session = this.checkoutSession
      const checkoutContent = session.checkoutFormContent
      const container = document.getElementById('iyzipay-checkout-form-container')
      this.requestInFlight = true
      const mounted = await mountIyzicoCheckout(container, checkoutContent)
      if (!this.isCheckoutOperationCurrent(generation) || this.checkoutSession !== session) return false
      if (!mounted) {
        this.cleanupCheckoutDom()
        this.mountFailureCount += 1
        this.checkoutPhase = 'mount-failed'
      } else {
        this.checkoutPhase = 'open'
      }
      if (this.isCheckoutOperationCurrent(generation)) this.requestInFlight = false
      return mounted
    },
    async retryCheckoutMount() {
      if (this.requestInFlight
        || this.offerChanged
        || !this.termCheck
        || !this.checkoutSession
        || !this.offer) return
      const generation = this.beginCheckoutOperation()
      this.requestInFlight = true
      try {
        const preflight = await this.loadSubscriptionStatus(generation)
        if (!this.isCheckoutOperationCurrent(generation)) return
        if (!preflight.ok) {
          await this.showPreflightUnavailable(generation)
          return
        }
        if (!preflight.matches) {
          this.discardCheckoutSession()
          await this.handlePreflightMismatch(preflight, generation)
          return
        }
        const state = evaluatePendingCheckoutSession(this.checkoutSession, this.offer.planKey)
        if (state === 'plan-mismatch') {
          await this.showPendingPlanMismatch(this.checkoutSession, generation)
          return
        }
        if (state !== 'resumable') {
          this.discardCheckoutSession()
          await this.showPendingCheckoutWarning(generation)
          return
        }
        this.cleanupCheckoutDom()
        this.checkoutMountGeneration = generation
        this.checkoutPhase = 'open'
        await this.mountCheckoutForm()
      } finally {
        if (this.isCheckoutOperationCurrent(generation)) this.requestInFlight = false
      }
    },
    cleanupCheckoutDom() {
      const container = document.getElementById('iyzipay-checkout-form-container')
      cleanupIyzicoCheckout(container)
    },
    discardCheckoutSession() {
      this.cleanupCheckoutDom()
      this.checkoutSession = null
      this.checkoutResumeNotice = false
      this.mountFailureCount = 0
      if (!['offer-changed', 'recovery-wait'].includes(this.checkoutPhase)) {
        this.checkoutPhase = 'idle'
      }
    },
    handleCheckoutModalHidden() {
      this.operationGeneration += 1
      this.checkoutMountGeneration = this.operationGeneration
      this.requestInFlight = false
      this.cleanupCheckoutDom()
      if (!this.checkoutSession) {
        this.checkoutPhase = 'idle'
        return
      }
      const state = evaluatePendingCheckoutSession(
        this.checkoutSession,
        this.offer && this.offer.planKey,
      )
      if (state === 'resumable') {
        this.checkoutPhase = 'closed-resumable'
      } else {
        this.discardCheckoutSession()
      }
    },
    reloadCheckoutPage() {
      if (this.checkoutSession && this.checkoutSession.serverResumable) window.location.reload()
    },
    formSubmitted() {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: 'Form Submitted',
          icon: 'EditIcon',
          variant: 'success',
        },
      })
    },
    saveAddress() {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: 'Address Saved',
          icon: 'EditIcon',
          variant: 'success',
        },
      })
    },
    validationForm() {
      this.$refs.simpleRules.validate().then(success => {
        if (success) {
          // eslint-disable-next-line
          this.postAddress();
          this.$refs.addressModal.hide()
        }
      })
    },
  },
}
</script>
<!-- <style scoped lang="scss">
  @import "@core/scss/vue/libs/vue-wizard.scss";
  @import "@core/scss/vue/libs/vue-select.scss";
</style> -->
<style scoped lang="scss">
.address-list {
  overflow-y: auto;
}

small {
  font-size: 12px;
  color: #ea5455;
}

.table-row {
  display: flex;
  justify-content: end;
  align-items: center;
  /* padding: 0.5rem 0; */
  /* border-bottom: 1px solid #e9ecef; */
}

.price-per-sub,
.sub-total,
.discount,
.total,
.tax {
  width: 100%;
  text-align: right;
  font-size: 14px;
  font-weight: 600;
  border-bottom: #e9ecef 1px solid;
  padding: 5px;
  /* background-color: #17a2b8; */
  color: #fff;
}

.price-per-p,
.sub-total-p,
.discount-p,
.total-p,
.tax-p {
  width: 100%;
  text-align: right;
  font-size: 14px;
  font-weight: 600;
  border-bottom: #e9ecef 1px solid;
  border-left: #e9ecef 1px solid;
  padding: 5px;
  /* background-color: #28c76f; */
  color: #fff;
  border-radius: 0 10px 10px 0;
}

.checkout-disclosure {
  background-color: #fffbf0;
}

/* PM 05.08.2026 item 4: the heading and the package lines rendered as one
   solid block -- each line wraps onto two rows, so with no gap between items a
   wrapped line was indistinguishable from the next item. The 1rem gap matches
   the spacing the offer card and the subscription summary card already use for
   this same list. */
.package-info h3 {
  margin-bottom: 1.25rem;
}

.package-info ul {
  margin-bottom: 0;
  padding-left: 1.25rem;
}

.package-info li {
  line-height: 1.5;
}

.package-info li + li {
  margin-top: 1rem;
}
</style>
